var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NoResultFound"},[_c('h2',{staticClass:"color-aili-white chantal"},[_vm._v(" Sembra che la tua ricerca non abbia dato risultati, tranne il fantasma formaggino. ")]),_c('img',{staticClass:"ghost",attrs:{"src":require('../../assets/ghost.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }